

(() => {
  'use strict';

  // c_breadcrumb.js
  // Boostの絞り込み（/collections/{handle}/{tag} のパス型URL）に合わせて
  // テーマのパンくずをURLから組み直す。他案件へ流用しやすいよう、特定セクションに依存しない。
  //
  // コレクション表示名の解決順（多層フォールバック）:
  //   1. data-collection-names（[data-collection-names] を持つ任意の要素。
  //      snippets/c_collection-names.liquid で出力）… 安定・優先
  //   2. Boostのフィルタ項目クリックで学習した実行時キャッシュ（対応表に無いコレクション用）
  //   3. どちらも無ければ、そのURLのサーバー描画をスナップショット保存/復元して凌ぐ
  //
  // 前提と制約:
  //   - タグ表示名はURLのデコード値を使う（英字タグは Half Sleeve → half-sleeve と非対応）。
  //   - 親階層メタフィールド（collection.metafields.custom.breadcrumb）は反映しない
  //     （ホーム > コレクション > タグ の3階層のみ）。
  //   - コレクションリンクは '/collections/' + handle で生成。多言語サブパス（/en/…）は非対応。

  // 複数セクションで読み込まれても初期化は1回だけ
  if (window.__cBreadcrumbInit) return;
  window.__cBreadcrumbInit = true;

  const SELECTOR = {
    collectionNames: '[data-collection-names]',
    boostItem: '[data-action="select-filter-item"]',
    breadcrumbList: '.c_breadcrumb .breadcrumb__list',
  };

  function normalizePath(path) {
    if (!path) return '';
    let decoded = path;
    try {
      decoded = decodeURIComponent(path);
    } catch (error) {
      decoded = path;
    }
    if (decoded.length > 1 && decoded.endsWith('/')) {
      decoded = decoded.slice(0, -1);
    }
    return decoded;
  }

  // Liquidが出力した handle→表示名 の対応表（推測せず実データを使う）
  function getCollectionNames() {
    const el = document.querySelector(SELECTOR.collectionNames);
    if (!el || !el.dataset.collectionNames) return {};
    try {
      return JSON.parse(el.dataset.collectionNames);
    } catch (error) {
      return {};
    }
  }

  // Boostのフィルタ項目クリックで学習する handle→表示名（対応表フォールバック）
  const runtimeNames = {};

  function parseBoostMeta(button) {
    let raw = button.getAttribute('data-metadata') || button.getAttribute('metadata');
    if (!raw) {
      const inner = button.querySelector('[data-metadata]');
      if (inner) raw = inner.getAttribute('data-metadata');
    }
    if (!raw) return null;
    try {
      const data = JSON.parse(raw);
      return (data && data.action && data.action.optionCollection) || null;
    } catch (error) {
      return null;
    }
  }

  function learnCollectionName(event) {
    const button = event.target.closest(SELECTOR.boostItem);
    if (!button) return;
    const meta = parseBoostMeta(button);
    if (!meta || meta.filterType !== 'collection') return;
    if (meta.handle && meta.displayName) {
      runtimeNames[meta.handle] = meta.displayName;
    }
  }

  /* ========== パンくずをURLに追従 ========== */
  // URLは /collections/{handle}[/{tag}] のパス型。Boostは絞り込み・戻る/進むで
  // パンくず領域を汎用表示（例:「商品一覧」）に再描画して上書きするため、
  // MutationObserver で上書きを検知し、URLから作った正しい状態を再適用する。

  let observer = null;
  let observedList = null;

  // ナビ対応表に無いコレクション（例: all）用に、URLごとのサーバー描画を保存/復元する
  const snapshots = new Map();

  function urlKey() {
    return normalizePath(window.location.pathname);
  }

  function getBreadcrumbList() {
    return document.querySelector(SELECTOR.breadcrumbList);
  }

  function makeBreadcrumbItem(label, url, separatorSource) {
    const item = document.createElement('li');
    item.className = 'breadcrumb__item';

    if (url) {
      const link = document.createElement('a');
      link.className = 'breadcrumb__link link';
      link.href = url;
      link.textContent = label;
      item.appendChild(link);
      if (separatorSource) {
        item.appendChild(separatorSource.cloneNode(true));
      }
    } else {
      const current = document.createElement('span');
      current.className = 'breadcrumb__link';
      current.textContent = label;
      item.appendChild(current);
    }

    return item;
  }

  function parseCollectionPath() {
    const parts = normalizePath(window.location.pathname).split('/').filter(Boolean);
    const i = parts.indexOf('collections');
    if (i === -1) return null;
    return {
      handle: parts[i + 1] || '',
      tag: parts[i + 2] || '',
    };
  }

  // コレクション名の解決: 対応表 → Boost学習キャッシュ の順
  function collectionNameFor(handle) {
    const names = getCollectionNames();
    if (names[handle]) return names[handle];
    if (runtimeNames[handle]) return runtimeNames[handle];
    return '';
  }

  // home以降の項目テキストを署名化（現在の内容が正しいかの判定用）
  function tailSignature(list) {
    const items = Array.prototype.slice.call(list.querySelectorAll('.breadcrumb__item'), 1);
    return items.map((item) => (item.textContent || '').replace(/\s+/g, ' ').trim()).join('>>');
  }

  function applyBreadcrumb() {
    const list = getBreadcrumbList();
    if (!list) return;

    const info = parseCollectionPath();
    if (!info || !info.handle) return;

    const homeItem = list.querySelector('.breadcrumb__item');
    if (!homeItem) return;

    // Boostがlist要素ごと差し替えた場合に備えて監視対象を張り直す
    ensureObserver(list);

    const collectionName = collectionNameFor(info.handle);

    // ナビ対応表に無いコレクション（例: all）は名前を組み立てられない。
    // 初回はサーバー描画を保存し、戻ってきた時に復元する。
    if (!collectionName) {
      const key = urlKey();
      if (snapshots.has(key)) {
        const html = snapshots.get(key);
        if (list.innerHTML !== html) {
          writeList(list, () => {
            list.innerHTML = html;
          });
        }
      } else {
        snapshots.set(key, list.innerHTML);
      }
      return;
    }

    // タグなし: ホーム > コレクション名（現在地）
    // タグあり: ホーム > コレクション名（リンク） > タグ（現在地）
    const expected = info.tag ? collectionName + '>>' + info.tag : collectionName;
    if (tailSignature(list) === expected) return;

    writeList(list, () => {
      const separatorSource = homeItem.children[1] || null;
      while (homeItem.nextElementSibling) {
        homeItem.nextElementSibling.remove();
      }
      if (info.tag) {
        list.appendChild(
          makeBreadcrumbItem(collectionName, '/collections/' + info.handle, separatorSource)
        );
        list.appendChild(makeBreadcrumbItem(info.tag, null, separatorSource));
      } else {
        list.appendChild(makeBreadcrumbItem(collectionName, null, separatorSource));
      }
    });
  }

  // 自分の書き換えで observer が再帰しないよう、書き込み中は監視を止める
  function writeList(list, mutate) {
    if (observer) observer.disconnect();
    mutate();
    if (observer && observedList === list) {
      observer.observe(list, { childList: true, subtree: true, characterData: true });
    }
  }

  function ensureObserver(list) {
    if (observedList === list && observer) return;
    if (!observer) observer = new MutationObserver(() => applyBreadcrumb());
    observer.disconnect();
    observedList = list;
    observer.observe(list, { childList: true, subtree: true, characterData: true });
  }

  /* ========== URL変化の検知（pushState/replaceState/戻る） ========== */

  // pushState/replaceState を監視して c:locationchange を発火（複数ファイルで二重適用しない）
  function ensureHistoryPatched() {
    if (window.__cHistoryPatched) return;
    window.__cHistoryPatched = true;
    ['pushState', 'replaceState'].forEach((method) => {
      const original = history[method];
      history[method] = function patched(...args) {
        const result = original.apply(this, args);
        window.dispatchEvent(new Event('c:locationchange'));
        return result;
      };
    });
  }

  ensureHistoryPatched();
  applyBreadcrumb();

  // Boostのフィルタ項目クリックで名前を学習（描画自体はURL変化で行う）
  document.addEventListener('click', learnCollectionName);
  window.addEventListener('popstate', applyBreadcrumb);
  window.addEventListener('c:locationchange', applyBreadcrumb);
  document.addEventListener('shopify:section:load', applyBreadcrumb);
})();
